import React from 'react';
import LinkElement from "./LinkElement";

export default ({linkTo, target, iconFirst, iconLast, data, greyOverlay, onClick}) => {

    const greyTextClass = data.doed && greyOverlay ? "grey-text" : "";

    return (
        <li className="border-list">
            <LinkElement to={linkTo} target={target} onClick={onClick}>
                <span className="regNr-dogName">
                            <img className="icon arrow" src={iconFirst} alt="" />
                            <span className={`hund ${greyTextClass}`}>{data.hundId}</span>
                            <span className={`rase ${greyTextClass}`}>{data.raseNavn}</span>
                            <br/>
                            <span className={`dogName ${greyTextClass}`}>{data.navn}</span>
                        </span>
                <img className="icon arrow" src={iconLast} alt="" />
            </LinkElement>

        </li>
    )
}
